@charset "UTF-8";

/* src/app/commonComponents/folder-tree-select/folder-tree-select.component.scss */
:host {
  display: block;
}
:host(.folder-tree--disabled) .folder-tree__field {
  pointer-events: none;
}
:host(.folder-tree--disabled) .folder-tree__field input {
  background: #f9f9f9;
  color: #7d8893;
}
:host(.folder-tree--disabled) .folder-tree__arrow {
  color: #333333;
}
.filter-dropdown-container {
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: 100%;
}
.filter-dropdown-container .filter-dropdown {
  position: relative;
  right: auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: 100%;
}
.folder-tree__panel.dropdown-wrapper.basic.card {
  min-width: 0;
  max-width: 100%;
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: 100%;
}
.folder-tree {
}
.folder-tree__field {
  position: relative;
  display: flex;
  cursor: pointer;
  margin-bottom: 13px;
}
.folder-tree__field input {
  cursor: pointer;
  margin-bottom: 0 !important;
  padding-right: 32px !important;
  text-overflow: ellipsis;
}
.folder-tree__field:hover input:not(:disabled) {
  border-color: #cfe0fa;
  box-shadow: rgb(199, 221, 255) 0 0 0 2px !important;
}
.folder-tree__field .icon-container {
  width: 30px;
  height: 32px;
  z-index: 10;
  position: absolute;
  right: 1px;
  top: 1px;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 0px 5px 5px 0;
}
.folder-tree__field .icon-container:hover {
  background: #f4f4f4;
}
.folder-tree__field .icon-container .folder-tree__arrow {
  font-size: 6px;
  color: #333333;
  transition: transform 0.2s cubic-bezier(0.41, 0.03, 0.45, 1.01);
  pointer-events: none;
}
.folder-tree__field .icon-container .folder-tree__arrow::before {
  display: block;
  transform: rotate(90deg);
  transition: transform 0.2s cubic-bezier(0.41, 0.03, 0.45, 1.01);
}
.folder-tree__field .icon-container .folder-tree__arrow--up::before {
  transform: rotate(270deg);
}
.folder-tree__list {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  padding: 8px 6px 8px 8px;
  max-height: min(260px, 40vh);
  overflow-x: hidden;
  overflow-y: auto;
}
.folder-tree__search {
  flex: 0 0 auto;
  padding: 8px 8px 0;
}
.folder-tree__search input {
  width: 100%;
  height: 32px;
  padding: 0 12px;
  font-size: 14px;
  letter-spacing: 0.12px;
  color: #2c2c2c;
  background: #ffffff;
  border: 1px solid #eaecf0;
  border-radius: 6px;
  transition: 0.2s cubic-bezier(0.41, 0.03, 0.45, 1.01);
}
.folder-tree__search input::placeholder {
  color: #989da7;
}
.folder-tree__search input:focus,
.folder-tree__search input:hover {
  border-color: #cfe0fa;
  box-shadow: rgb(199, 221, 255) 0 0 0 2px;
}
.folder-tree__empty {
  padding: 6px 8px;
  font-size: 13px;
  color: #858b98;
}
.folder-tree__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 0 0 44px;
  height: 44px;
  padding: 0 12px;
  background: #fafafa;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.031372549);
}
.folder-tree__node {
  position: relative;
}
.folder-tree__row {
  position: relative;
  padding-right: 16px !important;
}
.folder-tree__row--selected {
  background-color: #eff0f2 !important;
}
.folder-tree__row--selected .folder-tree__badge {
  background: #DCE2F2;
}
.folder-tree__row:hover .folder-tree__name,
.folder-tree__row--selected .folder-tree__name {
  text-decoration: underline;
}
.folder-tree__row--expanded::after {
  content: "";
  position: absolute;
  left: 14px;
  top: 23px;
  bottom: -2;
  width: 1px;
  background: #EDEFF5;
}
.folder-tree__icon {
  flex-shrink: 0;
  width: 15px;
  height: 14px;
}
.folder-tree__name {
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #1C2B4B;
}
.folder-tree__badge {
  flex: 0 0 auto;
  margin-left: 8px;
  padding: 2px 6px;
  font-size: 11px;
  line-height: 16px;
  font-weight: 500;
  white-space: nowrap;
  color: #237AED;
  background: #EFF3FF;
  border-radius: 4px;
  margin-right: 5px;
}
.folder-tree__toggle {
  margin-left: auto;
  font-size: 6px;
  color: #333;
  transform: rotate(90deg);
  transition: transform 0.2s cubic-bezier(0.41, 0.03, 0.45, 1.01);
}
.folder-tree__toggle--open {
  transform: rotate(-90deg);
}
.folder-tree__children {
  position: relative;
  margin-left: 14px;
  padding-left: 13px;
  overflow: hidden;
}
.folder-tree__children > .folder-tree__node::before {
  content: "";
  position: absolute;
  left: -13px;
  top: 1px;
  width: 1px;
  height: calc(100% + 1px);
  background: #EDEFF5;
}
.folder-tree__children > .folder-tree__node::after {
  content: "";
  position: absolute;
  left: -13px;
  top: 16px;
  width: 7px;
  height: 1px;
  background: #EDEFF5;
}
.folder-tree__children > .folder-tree__node:last-child::before {
  height: 16px;
  width: 6px;
  background: none;
  border-left: 1px solid #EDEFF5;
  border-bottom: 1px solid #EDEFF5;
  border-bottom-left-radius: 2px;
}
.folder-tree__children > .folder-tree__node:last-child::after {
  display: none;
}
